import Stack from '@mui/material/Stack';

import { RankTagProps } from './props';
import Tag from './tag';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const RankTag: React.FC<RankTagProps> = (props) => {
  const { rank } = props;

  let gradientId;
  let label = rank?.toString() ?? '';
  switch (rank) {
    case 1:
      gradientId = 'top1';
      label = 'TOP 1';
      break;
    case 2:
      gradientId = 'top2';
      label = 'TOP 2';
      break;
    case 3:
      gradientId = 'top3';
      label = 'TOP 3';
      break;
    default:
      gradientId = 'normal';
  }

  // ============ VIEWS
  return (
    <Stack>
      <Tag gradientId={gradientId} text={label} />
    </Stack>
  );
};

/**
 * ===========================
 * EXPORT
 * ===========================
 */
export default RankTag;
